import { axios } from '@Root/API'

export const sendFormEmailToAdmissions = (emailId, admissionDetailIds) => {
  return axios.post(`cognito-form-emails/${emailId}/send-to-admissions`, {
    admission_detail_ids: admissionDetailIds,
  })
}
